import { ConfigEntryType } from 'config/config';
import * as Yup from 'yup';

export const getPredefinedFieldValidation = ({
  field,
}: {
  field: ConfigEntryType;
}) => {
  switch (field.entryCode) {
    case 'phoneNumber':
      return field.referenceObject?.isRequired
        ? Yup.string()
            .matches(/^\(\d{3}\) \d{3}-\d{4}$/, 'Phone number must be in the format (123) 456-7890')
            .required('Phone number is required')
        : Yup.string()
            .nullable()
            .notRequired() 
            .test(
              'is-valid-phone',
              'Phone number must be in the format (123) 456-7890',
              (value) => !value || /^\(\d{3}\) \d{3}-\d{4}$/.test(value),
            );

    default: {
      return null;
    }
  }
};
